import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ProfileContext } from 'context';
import { getStandards } from 'helpers/standards';
import { countrySettings as countrySettingsSelector } from 'modules/App/selectors';
export const useStandards = ()=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const clinicSettings = useSelector(profileContext.selectors.clinicSettings);
    const countrySettings = useSelector(countrySettingsSelector);
    return getStandards(phiSet, countrySettings, clinicSettings);
};
